import { CartProductType, type CartProduct } from '@/app/[locale]/order/_context/order-flow-context'

/**
 * Stable React key and `useCartPrices` map id for one cart line.
 *
 * @param lineIndex - Disambiguates multiple lines with the same underlying product id (e.g. family bundle).
 */
export function cartProductKey(product: CartProduct, lineIndex: number): string {
	switch (product.type) {
		case CartProductType.TEMPLATE:
			return `${product.type}-${product.data.timeslotId}-i${lineIndex}`
		case CartProductType.PRICE_LIST_ITEM:
			return `${product.type}-${product.data.itemId}-i${lineIndex}`
		default:
			return `${product.type}-${product.data.programId}-i${lineIndex}`
	}
}
